import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface ExhaustSystemProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function ExhaustSystem(props: ExhaustSystemProps) {
  return (
    <svg
      width="1119"
      height="118"
      viewBox="0 0 1119 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 108, left: 238}}
      onClick={props.onClick}
    >
      <path
        d="M224 63.9995C242 63.9995 242 89.9995 263 89.9995H348.5C348.5 89.9995 351 91.5005 351 97.0005C351 102.472 348.525 103.984 348.5 104H255C234 104 234 77.9995 216 77.9995H174V63.9995H224Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M984 21.9995H968C963 21.9995 962.5 21.9999 959 28.9995C952.21 42.5787 927.734 89.3606 924 95.9995C919.5 104 915 104 904 104H432V89.9995H904C907 89.9995 909.413 88.195 913 81.9995C918.5 72.4985 947 14.9995 947 14.9995C947.025 14.9409 950.034 7.99951 958 7.99951H984V21.9995Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M106 77.9995H23C18.0001 77.9995 16.0001 79.9998 16 84.9995V94.9995L1 95.0005V79.0005C1 71.0005 4 63.9995 16 63.9995H106V77.9995Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M1068 22.0005H1052V8.00049H1068V22.0005Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M182 78C182 78 198 78 216 78C234 78 234 104 255 104H341"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M182 64C182 64 206 64 224 64C242 64 242 90 263 90H341"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M261 90C263.645 95.1379 263.689 98.189 261 104"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M213 64C215.645 69.1379 215.689 72.1889 213 78"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M98 64L16 64C4 64 1 71 1 79V95L16 95V85C16 80 18 78 23 78H98"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M23.6895 64C21.4554 69.1379 21.4181 72.1889 23.6895 78"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M1 86C6.50489 88.6445 9.77385 88.6887 16 86"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M442 90H904C907 90 909.413 88.1955 913 82C918.5 72.5 947 15 947 15C947 15 950 7.99995 958 7.99995C964 7.99995 960 7.99996 976 7.99996"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M442 104C624.375 104 721.625 104 904 104C915 104 919.5 104 924 96C927.734 89.3622 952.21 42.5794 959 29C962.5 22 963 22 968 22C974 22 960 22 976 22"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M585 90C587.234 95.1379 587.271 98.1889 585 104"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M903 90C905.645 95.1379 905.689 98.1889 903 104"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M966 8C968.645 13.1379 968.689 16.1889 966 22"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M1040 1.00049C1044.42 1.00049 1046.39 2.22215 1047.28 5.00049H1050C1052 5 1052 7.00049 1052 7.00049V23.0005C1052 23.036 1051.98 25 1050 25.0005H1047.28C1046.39 27.7788 1044.42 29.0005 1040 29.0005H996C991.581 29.0005 989.606 27.7788 988.721 25.0005H986C984.018 25 984 23.036 984 23.0005V7.00049C984 7.00049 984 5 986 5.00049H988.386C989.108 2.22151 991.028 1.00049 996 1.00049H1040Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M984 23V7C984 7 984 5 986 5.00049H988V25.0005H986C984 25 984 23 984 23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1052 23V7C1052 7 1052 5 1050 5.00049H1048V25.0005H1050C1052 25 1052 23 1052 23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M976 8.00049H984M984 22.0005H976"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1060 8.00049H1052M1052 22.0005H1060"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1018 29.0005H1040C1048 29.0005 1048 25.0005 1048 15.0005C1048 5.00049 1048 1.00048 1040 1.00048H1018L996 1.00049C987 1.00049 988 5.00048 988 15.0005C988 25.0005 988 29.0005 996 29.0005L1018 29.0005Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M994 1.00049V29.0005"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M1042 1.00049V29.0005"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M994 8.5H1042"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M1103 5.00049C1111 5.00049 1118 5.00069 1118 15.0005C1118 25.0003 1111 25.0005 1103 25.0005H1080.03C1076.31 25.0005 1074.32 24.3815 1073.26 23.0005H1070.5C1068.02 23 1068 21.036 1068 21.0005V9.00049C1068 9.00049 1068 7 1070.5 7.00049H1072.86C1073.82 5.61927 1075.84 5.00052 1080.03 5.00049H1103Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M1073 7.00049H1070.5C1068 7 1068 9 1068 9V21C1068 21 1068 23 1070.5 23.0005H1073"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1060 8.00049H1068M1068 22.0005H1060"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1094.02 25.0005H1103C1111 25.0005 1118 25.0005 1118 15.0005C1118 5.00049 1111 5.00049 1103 5.00049H1094.02L1080.03 5.00049C1071.03 5.00049 1072.03 7.85763 1072.03 15.0005C1072.03 22.1433 1072.03 25.0005 1080.03 25.0005H1094.02Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1097 25.0005C1105 25.0005 1113 25.0005 1113 15.0005C1113 5.00049 1105 5.00049 1097 5.00049"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M170 61H172C174 61 174 63 174 63V79C174 79 174 81 172 81H170L161.188 91H118.812L110 81H108C106 81 106 79 106 79V63C106 63 106 61 108 61H110L118.812 51H161.188L170 61Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M118.811 91H140.577H161.189L170 81V71V61L161.189 51H140.577H118.811L110 61V71V81L118.811 91Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        x="122"
        y="56"
        width="4"
        height="30"
        rx="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="130"
        y="56"
        width="4"
        height="30"
        rx="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="138"
        y="56"
        width="4"
        height="30"
        rx="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="146"
        y="56"
        width="4"
        height="30"
        rx="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="154"
        y="56"
        width="4"
        height="30"
        rx="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M106 79V63C106 63 106 61 108 61H110V81H108C106 81 106 79 106 79Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M174 79V63C174 63 174 61 172 61H170V81H172C174 81 174 79 174 79Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M98 64H106M106 78H98"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M174 64H182M182 78H174"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M426 77C429.038 77 432 85.9543 432 97C432 108.046 429.038 117 426 117H348.5V116.971C346.157 116.543 343.911 111.276 343 104H348C349.657 104 351 100.866 351 97C351 93.134 349.657 90 348 90H343C343.911 82.7236 346.157 77.4554 348.5 77.0283V77H426Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M343 90C343.95 82.4067 346.355 77 348.807 77C351.962 77 354 85.9543 354 97C354 108.046 351.962 117 348.807 117C346.355 117 343.95 111.593 343 104"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M347.447 90C348.445 82.4067 350.971 77 353.545 77C356.859 77 359 85.9543 359 97C359 108.046 356.859 117 353.545 117C350.971 117 348.445 111.593 347.447 104"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M358.5 87H426"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M421 117C424.038 117 427 108.046 427 97C427 85.9543 424.038 77 421 77"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M348.5 117H426C429.038 117 432 108.046 432 97C432 85.9543 429.038 77 426 77H348.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M341 104H348C349.657 104 351 100.866 351 97C351 93.134 349.657 90 348 90H341"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M432 90H434.222C435.695 90 436 93.134 436 97C436 100.866 435.695 104 434.222 104H432"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M344 104C345.657 104 347 100.866 347 97C347 93.134 345.657 90 344 90"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M434 90H442M442 104H434"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
